import { EMOJI_CACHE_SIZE } from '@/components/FloatingEmoji/floatingEmoji.constants';
import logger from '@/services/logger.service';
import store from '@/store';
import { DeviceTier } from '@/views/event/FloatingEmoji/types';

const emojiTextureCache = new Map<string, HTMLCanvasElement>();
const EMOJI_FONT = `${EMOJI_CACHE_SIZE * 0.8}px "Apple Color Emoji", "Segoe UI Emoji", "Noto Color Emoji", sans-serif`;

export function getEmojiTexture(emoji: string): HTMLCanvasElement {
  const cached = emojiTextureCache.get(emoji);
  if (cached) {
    return cached;
  }

  const offscreen = document.createElement('canvas');
  offscreen.width = EMOJI_CACHE_SIZE;
  offscreen.height = EMOJI_CACHE_SIZE;
  const ctx = offscreen.getContext('2d');
  if (!ctx) {
    logger.warn('[FloatingEmoji] getEmojiTexture: canvas 2D context unavailable', { emoji });
    emojiTextureCache.set(emoji, offscreen);
    return offscreen;
  }

  ctx.font = EMOJI_FONT;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText(emoji, EMOJI_CACHE_SIZE / 2, EMOJI_CACHE_SIZE / 2);
  emojiTextureCache.set(emoji, offscreen);
  return offscreen;
}

export function getWatcherCount(): number {
  const eventState = store.state.event?.event;
  const broadcast = store.getters['event/currentBroadcast'];
  if (!eventState || !broadcast) {
    return 0;
  }
  return eventState.activeUserCountUsingMmid?.[broadcast.mmid] ?? 0;
}

const laneLastUsed: number[] = new Array(6).fill(0);

export function pickLane(laneCount: number): number {
  const now = performance.now();
  // Prefer a cooled-down lane (oldest first)
  let oldest = Infinity;
  let pick = 0;
  for (let i = 0; i < laneCount; i++) {
    if (laneLastUsed[i] < oldest) {
      oldest = laneLastUsed[i];
      pick = i;
    }
  }
  laneLastUsed[pick] = now;
  return pick;
}

export const rand = (min: number, max: number): number => Math.random() * (max - min) + min;

export function getDeviceTier(logicalWidth: number): DeviceTier {
  if (logicalWidth < 768) {
    return 'mobile';
  }
  if (logicalWidth < 1024) {
    return 'tablet';
  }
  return 'desktop';
}
